export class AuthTokenAuthResponse {
  email: string;
}
